import OverlayTips from "../OverlayTips";

function CustomizationPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

CustomizationPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".forInterfaces .sectionOption").eq(1), {
            messageKey: "tips.customization.upload_logo",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 20,
            offsetY: -20
        })

        this.add($(".forReports .sectionOption").eq(2), {
            messageKey: "tips.customization.show_logo",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 20,
            offsetY: -20
        })
    }
});

export default CustomizationPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/CustomizationPageOverlayTipsManager.js